import { useMyaccountState } from 'core/services/store/myaccount/hooks';
import { $, useModuleDefinition } from '@starberry/components';
import React, { useContext, useEffect } from 'react';
import { MyAccountContext } from 'core/services/store/myaccount/store';
import { Center, Heading } from '@chakra-ui/layout';
import { useBreakpointValue } from "@chakra-ui/react"
import { Spinner } from '@chakra-ui/spinner';
import MyPropertyBuyingPageDesktop from '../modules/MyPropertyBuyingPageDesktop';
import MyPropertyBuyingPageMobile from '../modules/MyPropertyBuyingPageMobile';

const BuyingPage = ({ children }) => {
  const { services: myAccountState } = useMyaccountState();
  const [myAccountStateData] = useContext(MyAccountContext);

  useEffect(() => {
    const id = window.location.pathname.split('/').pop();
    myAccountState.getProperty({ id });
  }, []);

  // if (myAccountStateData.error) {
  //   return (
  //     <Center p={50}>
  //       <Heading>Failed to load this property</Heading>
  //     </Center>
  //   );
  // }

  // if (myAccountStateData.loading) {
  //   return (
  //     <Center p={50}>
  //       <Spinner size="lg" />
  //     </Center>
  //   );
  // }

  return children;
};

const BreakpointDetect = (props) => {
  const [detectDevice, setDetectDevice] = React.useState('mobile');
  const breakpointValue = useBreakpointValue({ base: "mobile", lg: "desktop" });
  const MobileLayout = useModuleDefinition(MyPropertyBuyingPageMobile);
  const DesktopLayout = useModuleDefinition(MyPropertyBuyingPageDesktop);

  useEffect(() => {
    if (breakpointValue) {
      setDetectDevice(breakpointValue)
    }
  }, [breakpointValue]);

  if ('mobile' === detectDevice) {
    return <MobileLayout {...props} />
  } else {
    return <DesktopLayout {...props} />
  }
}

export default {
  $: 'Dashboard',
  title: $('state.myaccount.0.property.property_detail.display_address', 'Persona details title'),
  content: [
    {
      component: BuyingPage,
      children: {
        component: BreakpointDetect,
      },
    },
  ],
};
